import React, {Component} from 'react';
import {connect} from 'react-redux'
import GeneralDoc from './GeneralDoc'
class PaymentVoucherDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:{doc:{},itemlist:[]}}
  }

  componentDidMount(){
    
  }

  componentWillMount() {
    // Instantiate a Realtime client 
  }

  loadNewDoc(callback) {
    this.refs.genDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (callback!==undefined)
        callback(result.creditnote_no)
      
    },)
  }

  loadPONewDoc(docNo) {
    this.refs.genDoc.getWrappedInstance().loadPONewDoc(docNo)
  }

  loadData(docNo) {
    this.refs.genDoc.getWrappedInstance().loadData(docNo)
  }

  renameDoc() {
    
  }

  onDocClose() {
    if (this.props.onClose!==undefined)
      this.props.onClose()
  }

  render() {
    return(
      <GeneralDoc
        ref={'genDoc'}
        title={this.props.title} 
        docType={this.props.docType}
        docSName={this.props.docSName}
        docName={this.props.docName}
        docName={this.props.docName}
        poDocType={this.props.poDocType}
        show={this.props.show}
        showDiscount={false}
        onLoadData={(data)=>{
          this.setState({data:data})
        }}
        onClose={this.onDocClose.bind(this)}
      />
    )
  }
}

export default PaymentVoucherDoc = connect(
  (state) => ({messages: state.message.view.doc.DeliverySlipDoc}),null,null,{withRef:true}
)(PaymentVoucherDoc);





// WEBPACK FOOTER //
// ./src/view/doc/PaymentVoucherDoc.js